import React from 'react';
import PropTypes from 'prop-types';

import { Form } from 'react-bootstrap';
import Select from 'react-select';

import { SYSTEM_STATUS } from 'lib/constants';
import ProductListFilter from 'lib/enums/ProductListFilter';

function SystemStatusFilter({ selectedValue, updateFilters }) {
  const options = [
    {
      label: SYSTEM_STATUS.ARCHIVED,
      value: SYSTEM_STATUS.ARCHIVED,
    },
    {
      label: SYSTEM_STATUS.UNARCHIVED,
      value: SYSTEM_STATUS.UNARCHIVED,
    },
  ];

  return (
    <Form.Group>
      <Form.Label>System Status</Form.Label>
      <Select
        isClearable
        options={options}
        value={options.find(val => val.value === selectedValue)}
        onChange={opt => updateFilters(ProductListFilter.SYSTEM_STATUS, opt?.value)}
      />
    </Form.Group>
  );
}

SystemStatusFilter.propTypes = {
  selectedValue: PropTypes.string,
  updateFilters: PropTypes.func.isRequired,
};

export default SystemStatusFilter;
